import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PermissionService } from '../_services';

// JS-1871: /client/locations lives alongside /client/dashboard and /client/profile but needs
// a looser gate than ClientGuard (which requires View Clients, an agency-side privilege). The
// sidebar makes the link visible when the user has Self Service OR View Order, so this guard
// mirrors that rule — a client user who ordered a project needs to pick a location, so the
// surface is useful on both the self-service flow and the ordering flow.
@Injectable({ providedIn: 'root' })
export class ClientLocationsGuard implements CanActivate {
  constructor(private router: Router, private permissionService: PermissionService) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
    if (!currentUser) {
      return of(this.router.createUrlTree(['/login']));
    }

    return forkJoin({
      // JS-1920 (2026-10-16): any-of-6 + legacy fallback.
      selfService: this.permissionService.canAccessSelfServiceModule(),
      viewOrder: this.permissionService.canAccessFunctionality('View Order')
    }).pipe(
      map((flags) => {
        if (flags.selfService || flags.viewOrder) {
          return true;
        }
        const fallback = currentUser.role && currentUser.role.includes('client')
          ? '/client-dashboard'
          : '/project';
        return this.router.createUrlTree([fallback]) as UrlTree;
      }),
      catchError(() => of(this.router.createUrlTree(['/login']) as UrlTree))
    );
  }
}
